import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'batchType'
})
export class BatchTypePipe implements PipeTransform {
	transform(items: Array<any>, batchTypes: any = []): Array<any> {
		if (!items) {
			return [];
		}
		if (!batchTypes.length) {
			return items;
		}
		return items.filter(item => {
			return batchTypes.some(batchType => {
				console.log(batchType);
				return batchType === item.type;
			});
		});
	}
}
